import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

@Injectable()
export class IssueStrategyService {
  constructor (private http: Http) {
  }
}
